export default [
  /auto.drivers.([^.]*).relation/,
  /auto.drivers.([^.]*).principalVehicle/,
  /auto.drivers.([^.]*).firstName/,
  /auto.drivers.([^.]*).lastName/,
  /auto.drivers.([^.]*).DOB/,
  /auto.drivers.([^.]*).gender/,
  /auto.drivers.([^.]*).maritalStatus/,
]
